import axios from 'axios';

import { hlog } from '../common/util';
// import { CONFIG } from '../../config';
import store from '../../store';
import { activateLoader, deactivateLoader } from '../actions';
import { UPLOAD_FILE } from './api';

const CONTENT_TYPE = {
  X_WWW: 'application/x-www-form-urlencoded',
  JSON: 'application/json'
};

const requestMethod = 'POST';

const formatBody = (requestBody, contentType = CONTENT_TYPE.X_WWW) => ({
  method: requestMethod,
  headers: { 'Content-Type': contentType },
  body: JSON.stringify(requestBody)
});

export const HHAxiosRequest = (target, requestBody, showSpinner = true) => {
  hlog(requestBody);
  hlog(`Target: ${target}`);

  if (showSpinner) store.dispatch(activateLoader());

  const disableSpinner = () => { store.dispatch(deactivateLoader()); };

  return axios.post(target, requestBody)
    .then((res) => {
      disableSpinner();
      return res;
    })
    .catch((err) => {
      disableSpinner();
      return err;
    });
};

const HHRequest = (target, requestBody, showSpinner = true) => {
  hlog(formatBody(requestBody));
  hlog(`Target: ${target}`);
  hlog(JSON.stringify(requestBody));

  if (showSpinner) store.dispatch(activateLoader());

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(target, formatBody(requestBody));
      const result = await response.json();
      hlog(result);
      store.dispatch(deactivateLoader());
      resolve(result);
    } catch (error) {
      hlog(error);
      store.dispatch(deactivateLoader());
      reject(error);
    }
  });
};

export default HHRequest;

// export const HHAttachmentMetadataRequest = async (
//   fileId,
//   isFilestack = false
// ) => {
//   const infoUrl = 'https://upload.uploadcare.com/info/';
//   const publicKey = CONFIG.UPLOADCARE_KEY;
//   const url = isFilestack
//     ? `${fileId}/metadata`
//     : `${infoUrl}?pub_key=${publicKey}&file_id=${fileId}`;
//   const response = await fetch(url);
//   const result = await response.json();
//   return result;
// };

export const MentorRequest = async (target, requestBody) => {
  const response = await fetch(target, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(requestBody)
  });
  return response;
};

export const uploadImages = async (data, config) =>
  axios.post(
    UPLOAD_FILE,
    // 'http://localhost:3001/upload/',
    data,
    config
  );



// WEBPACK FOOTER //
// ./src/components/network/index.js